import { render, staticRenderFns } from "./PanelesConfiguracion.vue?vue&type=template&id=0b67144a&scoped=true&"
import script from "./PanelesConfiguracion.vue?vue&type=script&lang=ts&"
export * from "./PanelesConfiguracion.vue?vue&type=script&lang=ts&"
import style0 from "./PanelesConfiguracion.vue?vue&type=style&index=0&id=0b67144a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b67144a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0b67144a', component.options)
    } else {
      api.reload('0b67144a', component.options)
    }
    module.hot.accept("./PanelesConfiguracion.vue?vue&type=template&id=0b67144a&scoped=true&", function () {
      api.rerender('0b67144a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TorreControl/ControlConfiguracion/PanelesConfiguracion.vue"
export default component.exports